"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

var _sleepPromise = _interopRequireDefault(require("sleep-promise"));

var _terminal = _interopRequireDefault(require("terminal.js"));

var _socket = _interopRequireDefault(require("../../socket"));

var _utils = require("../../utils");

var _char = require("../../utils/char");

var _config = _interopRequireDefault(require("./config"));

function _wrapRegExp(re, groups) { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _RegExp = (0, _wrapNativeSuper2["default"])(RegExp); var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = _RegExp.call(this, re, flags); _groups.set(_this, groups || _groups.get(re)); return _this; } (0, _inherits2["default"])(BabelRegExp, _RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = []; args.push.apply(args, arguments); if ((0, _typeof2["default"])(args[args.length - 1]) !== "object") { args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Bot = /*#__PURE__*/function (_EventEmitter) {
  (0, _inherits2["default"])(Bot, _EventEmitter);

  var _super = _createSuper(Bot);

  (0, _createClass2["default"])(Bot, [{
    key: "line",
    get: function get() {
      var lines = [];

      for (var i = 0; i < this.term.state.rows; i++) {
        var _this$term$state$getL = this.term.state.getLine(i),
            str = _this$term$state$getL.str,
            attr = _this$term$state$getL.attr;

        lines.push({
          str: str,
          attr: Object.assign({}, attr)
        });
      }

      return lines;
    }
  }, {
    key: "screen",
    get: function get() {
      return this.line.map(function (line) {
        return line.str;
      }).join("\n");
    }
  }]);

  function Bot(config) {
    var _this;

    (0, _classCallCheck2["default"])(this, Bot);
    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "config", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "term", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "currentCharset", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "socket", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "preventIdleHandler", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getLine", function (n) {
      return _this.term.state.getLine(n);
    });
    _this.config = _objectSpread(_objectSpread({}, _config["default"]), config);

    _this.init();

    return _this;
  }

  (0, _createClass2["default"])(Bot, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this2 = this;

        var config, socket;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = this.config;
                this.term = new _terminal["default"](config.terminal);
                this.state = _objectSpread({}, Bot.initialState);
                this.term.state.setMode("stringWidth", "dbcs");
                this.currentCharset = "big5";
                _context.t0 = config.protocol.toLowerCase();
                _context.next = _context.t0 === "websocket" ? 8 : _context.t0 === "ws" ? 8 : _context.t0 === "wss" ? 8 : _context.t0 === "telnet" ? 9 : _context.t0 === "ssh" ? 9 : 9;
                break;

              case 8:
                return _context.abrupt("break", 11);

              case 9:
                throw new Error("Invalid protocol: ".concat(config.protocol));

              case 11:
                socket = new _socket["default"](config);
                socket.connect();
                Bot.forwardEvents.forEach(function (e) {
                  socket.on(e, _this2.emit.bind(_this2, e));
                });
                socket.on("connect", function () {
                  _this2.state.connect = true;
                  _this2.state.wsState = 1;

                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }

                  _this2.emit.apply(_this2, ["connect"].concat(args));

                  _this2.emit("stateChange", _this2.state);
                }).on("disconnect", function (closeEvent) {
                  _this2.state.connect = false; // let client know it disconnects
                  // this.state.login = false;

                  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                    args[_key2 - 1] = arguments[_key2];
                  }

                  _this2.emit.apply(_this2, ["disconnect", closeEvent].concat(args));

                  _this2.emit("stateChange", _this2.state);
                }).on("message", function (data) {
                  if (_this2.currentCharset !== _this2.config.charset && !_this2.state.login && (0, _utils.decode)(data, "utf8").includes("登入中，請稍候...")) {
                    _this2.currentCharset = _this2.config.charset;
                  }

                  var msg = (0, _utils.decode)(data, _this2.currentCharset);

                  _this2.term.write(msg);

                  _this2.emit("redraw", _this2.term.toString());
                }).on("error", function (err) {
                  console.log(err);
                  _this2.state.wsState = -1;

                  _this2.emit("websocket_error");
                });
                this.socket = socket;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }() // get state(): any {
    // 	return { ...this.state };
    // }

  }, {
    key: "getContentIterator",
    // This will return iterator of content.
    value: function getContentIterator() {
      var _this3 = this;

      var infoLine = this.line[23].str;
      var pgTotal = Number(infoLine.substring(infoLine.indexOf("第") + 2, infoLine.indexOf("頁") - 1).split("/")[1]); // console.log("pgtotal", pgTotal);

      var allRead = false;
      var firstPage = true;
      var index = 0;
      var lines = [];
      lines.push(this.line[0]);
      var iterator = {
        reset: function reset() {
          index = 0;
          allRead = false;
          firstPage = true;
        },
        next: function () {
          var _next = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
            var ni, pgNow, l, i, j, line, r;
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;

                    if (!(allRead || infoLine.includes("此文章無內容"))) {
                      _context2.next = 3;
                      break;
                    }

                    return _context2.abrupt("return", {
                      value: null,
                      done: true
                    });

                  case 3:
                    ni = 0;

                  case 4:
                    if (!(ni < _this3.config.numOfPagesPerIteration && !allRead)) {
                      _context2.next = 21;
                      break;
                    }

                    infoLine = _this3.line[23].str;
                    pgNow = Number(infoLine.substring(infoLine.indexOf("第") + 2, infoLine.indexOf("頁") - 1).split("/")[0]); // console.log("pgNow", pgNow);

                    l = void 0; // console.log("infoline", infoLine);

                    l = infoLine.substring(infoLine.lastIndexOf("第") + 2, infoLine.indexOf("行") - 1).split("~").map(Number); // console.log("l", l);

                    i = firstPage ? l[0] : l[0] + 1;

                    for (j = 1; j <= 22; i++, j++) {
                      line = _this3.line[j];

                      if (i > index) {
                        lines.push(line);
                        index++; // console.log("line ", i, ", index ",index," ", line);
                      }
                    }

                    firstPage = false; // last page

                    if (!(pgNow === pgTotal)) {
                      _context2.next = 16;
                      break;
                    }

                    allRead = true;
                    _context2.next = 18;
                    break;

                  case 16:
                    _context2.next = 18;
                    return _this3.send("".concat(_utils.keymap.PgDown));

                  case 18:
                    ni++;
                    _context2.next = 4;
                    break;

                  case 21:
                    // remove all empty lines at the end
                    if (allRead) {
                      while (lines.length > 0 && lines[lines.length - 1].str === "") {
                        index--;
                        lines.pop();
                      }
                    }

                    r = {
                      value: lines,
                      done: false
                    };
                    lines = [];
                    return _context2.abrupt("return", r);

                  case 27:
                    _context2.prev = 27;
                    _context2.t0 = _context2["catch"](0);
                    return _context2.abrupt("return", Promise.reject(_context2.t0));

                  case 30:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[0, 27]]);
          }));

          function next() {
            return _next.apply(this, arguments);
          }

          return next;
        }()
      };
      return iterator;
    } // This will return whole object.

  }, {
    key: "getContent",
    value: function () {
      var _getContent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var lines, sentPgDown, i, lastLine, _i, j;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                lines = [];
                lines.push(this.line[0]);
                sentPgDown = false;

              case 3:
                if (!(!this.line[23].str.includes("100%") && !this.line[23].str.includes("此文章無內容"))) {
                  _context3.next = 10;
                  break;
                }

                for (i = 1; i < 23; i++) {
                  lines.push(this.line[i]);
                }

                _context3.next = 7;
                return this.send(_utils.keymap.PgDown);

              case 7:
                sentPgDown = true;
                _context3.next = 3;
                break;

              case 10:
                lastLine = lines[lines.length - 1];
                _i = 0;

              case 12:
                if (!(_i < 23)) {
                  _context3.next = 19;
                  break;
                }

                if (!(this.line[_i].str === lastLine.str)) {
                  _context3.next = 16;
                  break;
                }

                for (j = _i + 1; j < 23; j++) {
                  lines.push(this.line[j]);
                }

                return _context3.abrupt("break", 19);

              case 16:
                _i++;
                _context3.next = 12;
                break;

              case 19:
                while (lines.length > 0 && lines[lines.length - 1].str === "") {
                  lines.pop();
                }

                if (!sentPgDown) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 23;
                return this.send(_utils.keymap.Home);

              case 23:
                return _context3.abrupt("return", lines);

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getContent() {
        return _getContent.apply(this, arguments);
      }

      return getContent;
    }()
    /**
     * @deprecated
     */

  }, {
    key: "getLines",
    value: function () {
      var _getLines = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var lines;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getContent();

              case 2:
                lines = _context4.sent;
                return _context4.abrupt("return", lines.map(function (line) {
                  return line.str;
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getLines() {
        return _getLines.apply(this, arguments);
      }

      return getLines;
    }()
  }, {
    key: "send",
    value: function send(msg) {
      var _this4 = this;

      if (this.config.preventIdleTimeout) {
        this.preventIdle(this.config.preventIdleTimeout);
      }

      return new Promise(function (resolve, reject) {
        var autoResolveHandler;

        var cb = function cb(message) {
          clearTimeout(autoResolveHandler);
          resolve(true);
        };

        if (_this4.state.connect) {
          if (msg.length > 0) {
            _this4.socket.send((0, _utils.encode)(msg, _this4.currentCharset));

            _this4.once("message", cb);

            autoResolveHandler = setTimeout(function () {
              _this4.removeListener("message", cb);

              resolve(false);
            }, _this4.config.timeout * 10);
          } else {
            console.info("Sending message with 0-length. Skipped.");
            resolve(true);
          }
        } else {
          reject();
        }
      });
    }
  }, {
    key: "preventIdle",
    value: function preventIdle(timeout) {
      var _this5 = this;

      clearTimeout(this.preventIdleHandler);

      if (this.state.login) {
        this.preventIdleHandler = setTimeout( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
          return _regenerator["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this5.send(_utils.keymap.CtrlU);

                case 2:
                  _context5.next = 4;
                  return _this5.send(_utils.keymap.ArrowLeft);

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        })), timeout * 1000);
      }
    }
  }, {
    key: "login",
    value: function () {
      var _login = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(username, password) {
        var kick,
            ret,
            state,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                kick = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : true;

                if (!this.state.login) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                username = username.replace(/,/g, "");

                if (this.config.charset === "utf8") {
                  username += ",";
                }

                _context6.next = 7;
                return this.send("".concat(username).concat(_utils.keymap.Enter).concat(password).concat(_utils.keymap.Enter));

              case 7:
                _context6.next = 9;
                return this.checkLogin(kick);

              case 9:
                ret = _context6.sent;

                if (ret) {
                  state = this.state;
                  state.login = true;
                  state.position = {
                    boardname: ""
                  };
                  this.state.username = username.substring(0, username.length - 1);
                  this.emit("stateChange", this.state);
                }

                return _context6.abrupt("return", ret);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function login(_x, _x2) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.state.login) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                _context7.next = 4;
                return this.send("G".concat(_utils.keymap.Enter, "Y").concat(_utils.keymap.Enter));

              case 4:
                this.state.login = false;
                this.emit("stateChange", this.state);
                this.send(_utils.keymap.Enter);
                return _context7.abrupt("return", true);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "checkLogin",
    value: function () {
      var _checkLogin = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(kick) {
        var state, lines;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.line[21].str.includes("密碼不對或無此帳號") || this.line[21].str.includes("請重新輸入"))) {
                  _context8.next = 5;
                  break;
                }

                this.emit("login.failed");
                return _context8.abrupt("return", false);

              case 5:
                if (!this.line[23].str.includes("請稍後再試")) {
                  _context8.next = 10;
                  break;
                }

                this.emit("login.failed");
                return _context8.abrupt("return", false);

              case 10:
                if (!this.line[13].str.includes("亂踹密碼會留下記錄喔")) {
                  _context8.next = 15;
                  break;
                }

                this.emit("login.failed");
                return _context8.abrupt("return", false);

              case 15:
                state = 0;

              case 16:
                if (!true) {
                  _context8.next = 66;
                  break;
                }

                _context8.next = 19;
                return (0, _sleepPromise["default"])(400);

              case 19:
                lines = this.line;

                if (!lines[22].str.includes("登入中，請稍候...")) {
                  _context8.next = 23;
                  break;
                }

                _context8.next = 64;
                break;

              case 23:
                if (!lines[22].str.includes("您想刪除其他重複登入的連線嗎")) {
                  _context8.next = 32;
                  break;
                }

                if (!(state === 1)) {
                  _context8.next = 26;
                  break;
                }

                return _context8.abrupt("continue", 16);

              case 26:
                _context8.next = 28;
                return this.send("".concat(kick ? "y" : "n").concat(_utils.keymap.Enter));

              case 28:
                state = 1;
                return _context8.abrupt("continue", 16);

              case 32:
                if (!lines[23].str.includes("請勿頻繁登入以免造成系統過度負荷")) {
                  _context8.next = 40;
                  break;
                }

                if (!(state === 2)) {
                  _context8.next = 35;
                  break;
                }

                return _context8.abrupt("continue", 16);

              case 35:
                _context8.next = 37;
                return this.send("".concat(_utils.keymap.Enter));

              case 37:
                state = 2;
                _context8.next = 64;
                break;

              case 40:
                if (!lines[23].str.includes("您要刪除以上錯誤嘗試的記錄嗎")) {
                  _context8.next = 48;
                  break;
                }

                if (!(state === 3)) {
                  _context8.next = 43;
                  break;
                }

                return _context8.abrupt("continue", 16);

              case 43:
                _context8.next = 45;
                return this.send("y".concat(_utils.keymap.Enter));

              case 45:
                state = 3;
                _context8.next = 64;
                break;

              case 48:
                if (!lines[23].str.includes("按任意鍵繼續")) {
                  _context8.next = 53;
                  break;
                }

                _context8.next = 51;
                return this.send("".concat(_utils.keymap.Enter));

              case 51:
                _context8.next = 64;
                break;

              case 53:
                if (!(lines[22].str + lines[23].str).toLowerCase().includes("y/n")) {
                  _context8.next = 59;
                  break;
                }

                console.info("Unknown login state: \n".concat(this.screen));
                _context8.next = 57;
                return this.send("y".concat(_utils.keymap.Enter));

              case 57:
                _context8.next = 64;
                break;

              case 59:
                if (!lines[23].str.includes("我是")) {
                  _context8.next = 63;
                  break;
                }

                return _context8.abrupt("break", 66);

              case 63:
                console.info("Unknown login state: \n".concat(this.screen));

              case 64:
                _context8.next = 16;
                break;

              case 66:
                this.emit("login.success");
                return _context8.abrupt("return", true);

              case 68:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function checkLogin(_x3) {
        return _checkLogin.apply(this, arguments);
      }

      return checkLogin;
    }()
    /**
     * @deprecated
     */

  }, {
    key: "checkArticleWithHeader",
    value: function checkArticleWithHeader() {
      var authorArea = (0, _char.substrWidth)("dbcs", this.line[0].str, 0, 6).trim();
      return authorArea === "作者";
    }
  }, {
    key: "select",
    value: function select(model) {
      return model.select(this);
    }
    /**
     * @deprecated
     */

  }, {
    key: "getMails",
    value: function () {
      var _getMails = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
        var offset,
            getLine,
            mails,
            i,
            line,
            mail,
            _args9 = arguments;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                offset = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : 0;
                _context9.next = 3;
                return this.enterMail();

              case 3:
                if (!(offset > 0)) {
                  _context9.next = 7;
                  break;
                }

                offset = Math.max(offset - 9, 1);
                _context9.next = 7;
                return this.send("".concat(_utils.keymap.End).concat(_utils.keymap.End).concat(offset).concat(_utils.keymap.Enter));

              case 7:
                getLine = this.getLine;
                mails = [];

                for (i = 3; i <= 22; i++) {
                  line = getLine(i).str;
                  mail = {
                    sn: +(0, _char.substrWidth)("dbcs", line, 1, 5).trim(),
                    date: (0, _char.substrWidth)("dbcs", line, 9, 5).trim(),
                    author: (0, _char.substrWidth)("dbcs", line, 15, 12).trim(),
                    status: (0, _char.substrWidth)("dbcs", line, 30, 2).trim(),
                    title: (0, _char.substrWidth)("dbcs", line, 33).trim()
                  };
                  mails.push(mail);
                }

                _context9.next = 12;
                return this.enterIndex();

              case 12:
                return _context9.abrupt("return", mails.reverse());

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getMails() {
        return _getMails.apply(this, arguments);
      }

      return getMails;
    }()
    /**
     * @deprecated
     */

  }, {
    key: "getMail",
    value: function () {
      var _getMail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(sn) {
        var getLine, hasHeader, mail;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.enterMail();

              case 2:
                getLine = this.getLine;
                _context10.next = 5;
                return this.send("".concat(sn).concat(_utils.keymap.Enter).concat(_utils.keymap.Enter));

              case 5:
                hasHeader = this.checkArticleWithHeader();
                mail = {
                  sn: sn,
                  author: "",
                  title: "",
                  timestamp: "",
                  lines: []
                };

                if (this.checkArticleWithHeader()) {
                  mail.author = (0, _char.substrWidth)("dbcs", getLine(0).str, 7, 50).trim();
                  mail.title = (0, _char.substrWidth)("dbcs", getLine(1).str, 7).trim();
                  mail.timestamp = (0, _char.substrWidth)("dbcs", getLine(2).str, 7).trim();
                }

                _context10.next = 10;
                return this.getLines();

              case 10:
                mail.lines = _context10.sent;
                _context10.next = 13;
                return this.enterIndex();

              case 13:
                return _context10.abrupt("return", mail);

              case 14:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getMail(_x4) {
        return _getMail.apply(this, arguments);
      }

      return getMail;
    }()
  }, {
    key: "enterIndex",
    value: function () {
      var _enterIndex = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.send("".concat(_utils.keymap.ArrowLeft.repeat(5)));

              case 2:
                return _context11.abrupt("return", true);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function enterIndex() {
        return _enterIndex.apply(this, arguments);
      }

      return enterIndex;
    }()
  }, {
    key: "goToTop",
    value: function () {
      var _goToTop = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.send("".concat(_utils.keymap.Home));

              case 2:
                return _context12.abrupt("return", true);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function goToTop() {
        return _goToTop.apply(this, arguments);
      }

      return goToTop;
    }()
  }, {
    key: "enterArticleByAIDFromBoard",
    // From board enter article with AID
    value: function () {
      var _enterArticleByAIDFromBoard = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(AID) {
        var query, res;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (this.state.login) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt("return", Promise.reject("not login"));

              case 2:
                query = "#".concat(AID).concat(_utils.keymap.Enter);
                _context13.next = 5;
                return this.send(query);

              case 5:
                res = _context13.sent;

                if (res) {
                  _context13.next = 10;
                  break;
                }

                _context13.next = 9;
                return this.send("".concat(_utils.keymap.Enter));

              case 9:
                return _context13.abrupt("return", Promise.reject("enterArticleByAIDFromBoard failed"));

              case 10:
                _context13.next = 12;
                return this.send("".concat(_utils.keymap.ArrowRight));

              case 12:
                return _context13.abrupt("return", Promise.resolve("now in article : ".concat(AID)));

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function enterArticleByAIDFromBoard(_x5) {
        return _enterArticleByAIDFromBoard.apply(this, arguments);
      }

      return enterArticleByAIDFromBoard;
    }() // Enter board and enter article with AID

  }, {
    key: "enterArticleByAID",
    value: function () {
      var _enterArticleByAID = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(boardname, AID) {
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (this.state.login) {
                  _context14.next = 2;
                  break;
                }

                return _context14.abrupt("return", Promise.reject("not login"));

              case 2:
                _context14.prev = 2;
                _context14.next = 5;
                return this.enterBoardByName(boardname);

              case 5:
                _context14.next = 7;
                return this.enterArticleByAIDFromBoard(AID);

              case 7:
                return _context14.abrupt("return", Promise.resolve("now in article : ".concat(AID)));

              case 10:
                _context14.prev = 10;
                _context14.t0 = _context14["catch"](2);
                return _context14.abrupt("return", Promise.reject(_context14.t0));

              case 13:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[2, 10]]);
      }));

      function enterArticleByAID(_x6, _x7) {
        return _enterArticleByAID.apply(this, arguments);
      }

      return enterArticleByAID;
    }() // This API is STATEFUL!
    // send comment in article, in search mode.
    //  res = {
    // 		"type" : "1" or "2" or "3"
    //  	"text" : "hello!"
    //    "boardName" : "test",
    //    "aid" : "aid"
    // }

  }, {
    key: "sendCommentSearchMode",
    value: function () {
      var _sendCommentSearchMode = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(res) {
        var text, lenPerLine, seperateText, _iterator, _step, t;

        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                text = res.text;
                text = text.trim();

                if (!(text.length === 0)) {
                  _context15.next = 4;
                  break;
                }

                return _context15.abrupt("return", Promise.reject("empty string"));

              case 4:
                lenPerLine = 52; // 中文字的長度是二

                seperateText = function seperateText(str) {
                  var textParts = [];
                  var strPart = "";

                  for (var i = 0, len = 0; i < str.length;) {
                    if (str[i] >= "\xFF") {
                      // cannot put it in
                      if (len >= lenPerLine - 1) {
                        textParts.push(strPart);
                        strPart = "";
                        len = 0;
                      } else {
                        strPart += str[i];
                        len += 2;
                        i++;
                      }
                    } else {
                      if (len == lenPerLine) {
                        textParts.push(strPart);
                        strPart = "";
                        len = 0;
                      } else {
                        strPart += str[i];
                        len += 1;
                        i++;
                      }
                    }
                  }

                  textParts.push(strPart);
                  return textParts;
                };

                text = seperateText(text);
                _context15.prev = 7;
                // We assume bot is in the correct article.
                _iterator = _createForOfIteratorHelper(text);
                _context15.prev = 9;

                _iterator.s();

              case 11:
                if ((_step = _iterator.n()).done) {
                  _context15.next = 29;
                  break;
                }

                t = _step.value;
                _context15.next = 15;
                return this.send("X");

              case 15:
                if (!this.line[23].str.includes("您覺得這篇文章")) {
                  _context15.next = 18;
                  break;
                }

                _context15.next = 18;
                return this.send("".concat(res.type));

              case 18:
                if (!(this.line[22].str.includes("使用 → 加註方式") || this.line[23].str.includes(this.state.username))) {
                  _context15.next = 25;
                  break;
                }

                _context15.next = 21;
                return this.send("".concat(t).concat(_utils.keymap.Enter));

              case 21:
                _context15.next = 23;
                return this.send("y".concat(_utils.keymap.Enter));

              case 23:
                _context15.next = 27;
                break;

              case 25:
                _context15.next = 27;
                return this.send("".concat(_utils.keymap.ArrowLeft));

              case 27:
                _context15.next = 11;
                break;

              case 29:
                _context15.next = 34;
                break;

              case 31:
                _context15.prev = 31;
                _context15.t0 = _context15["catch"](9);

                _iterator.e(_context15.t0);

              case 34:
                _context15.prev = 34;

                _iterator.f();

                return _context15.finish(34);

              case 37:
                return _context15.abrupt("return", Promise.resolve("comment success"));

              case 40:
                _context15.prev = 40;
                _context15.t1 = _context15["catch"](7);
                return _context15.abrupt("return", Promise.reject(_context15.t1));

              case 43:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[7, 40], [9, 31, 34, 37]]);
      }));

      function sendCommentSearchMode(_x8) {
        return _sendCommentSearchMode.apply(this, arguments);
      }

      return sendCommentSearchMode;
    }()
  }, {
    key: "enterArticle",
    value: function () {
      var _enterArticle = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function enterArticle() {
        return _enterArticle.apply(this, arguments);
      }

      return enterArticle;
    }() // send comment in article
    //  res = {
    // 		"type" : "1" or "2" or "3"
    //  	"text" : "hello!"
    //    "boardName" : "test",
    //    "aid" : "aid"
    // }

  }, {
    key: "sendComment",
    value: function () {
      var _sendComment = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(res) {
        var text, lenPerLine, seperateText, _iterator2, _step2, t;

        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.state.login) {
                  _context17.next = 2;
                  break;
                }

                return _context17.abrupt("return", Promise.reject("not login"));

              case 2:
                text = res.text;
                text = text.trim();

                if (!(text.length === 0)) {
                  _context17.next = 6;
                  break;
                }

                return _context17.abrupt("return", Promise.reject("empty string"));

              case 6:
                lenPerLine = 52; // 中文字的長度是二

                seperateText = function seperateText(str) {
                  var textParts = [];
                  var strPart = "";

                  for (var i = 0, len = 0; i < str.length;) {
                    if (str[i] >= "\xFF") {
                      // cannot put it in
                      if (len >= lenPerLine - 1) {
                        textParts.push(strPart);
                        strPart = "";
                        len = 0;
                      } else {
                        strPart += str[i];
                        len += 2;
                        i++;
                      }
                    } else {
                      if (len == lenPerLine) {
                        textParts.push(strPart);
                        strPart = "";
                        len = 0;
                      } else {
                        strPart += str[i];
                        len += 1;
                        i++;
                      }
                    }
                  }

                  textParts.push(strPart);
                  return textParts;
                };

                text = seperateText(text);
                _context17.prev = 9;
                _context17.next = 12;
                return this.enterBoardByName(res.boardName);

              case 12:
                _iterator2 = _createForOfIteratorHelper(text);
                _context17.prev = 13;

                _iterator2.s();

              case 15:
                if ((_step2 = _iterator2.n()).done) {
                  _context17.next = 31;
                  break;
                }

                t = _step2.value;
                _context17.next = 19;
                return this.enterArticle();

              case 19:
                _context17.next = 21;
                return this.send("X");

              case 21:
                if (!this.line[23].str.includes("您覺得這篇文章")) {
                  _context17.next = 24;
                  break;
                }

                _context17.next = 24;
                return this.send("".concat(res.type));

              case 24:
                if (!(this.line[22].str.includes("使用 → 加註方式") || this.line[23].str.includes(this.state.username))) {
                  _context17.next = 29;
                  break;
                }

                _context17.next = 27;
                return this.send("".concat(t).concat(_utils.keymap.Enter));

              case 27:
                _context17.next = 29;
                return this.send("y".concat(_utils.keymap.Enter));

              case 29:
                _context17.next = 15;
                break;

              case 31:
                _context17.next = 36;
                break;

              case 33:
                _context17.prev = 33;
                _context17.t0 = _context17["catch"](13);

                _iterator2.e(_context17.t0);

              case 36:
                _context17.prev = 36;

                _iterator2.f();

                return _context17.finish(36);

              case 39:
                _context17.next = 41;
                return this.enterIndex();

              case 41:
                return _context17.abrupt("return", Promise.resolve("comment success"));

              case 44:
                _context17.prev = 44;
                _context17.t1 = _context17["catch"](9);
                return _context17.abrupt("return", Promise.reject(_context17.t1));

              case 47:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[9, 44], [13, 33, 36, 39]]);
      }));

      function sendComment(_x9) {
        return _sendComment.apply(this, arguments);
      }

      return sendComment;
    }()
  }, {
    key: "enterBoardByName",
    value: function () {
      var _enterBoardByName = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(boardname) {
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.send("s".concat(boardname).concat(_utils.keymap.Enter, " ").concat(_utils.keymap.Home).concat(_utils.keymap.End));

              case 2:
                if (!(this.currentBoardname.toLowerCase() === boardname.toLowerCase())) {
                  _context18.next = 8;
                  break;
                }

                this.state.position.boardname = this.currentBoardname;
                this.emit("stateChange", this.state);
                return _context18.abrupt("return", Promise.resolve("now in board : ".concat(boardname)));

              case 8:
                _context18.next = 10;
                return this.enterIndex();

              case 10:
                return _context18.abrupt("return", Promise.reject("enterBoardByName failed"));

              case 11:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function enterBoardByName(_x10) {
        return _enterBoardByName.apply(this, arguments);
      }

      return enterBoardByName;
    }()
  }, {
    key: "enterByOffset",
    value: function () {
      var _enterByOffset = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20() {
        var _this6 = this;

        var offsets,
            result,
            _args20 = arguments;
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                offsets = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : [];
                result = true;
                offsets.forEach( /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19(offset) {
                    var i, lastOffset;
                    return _regenerator["default"].wrap(function _callee19$(_context19) {
                      while (1) {
                        switch (_context19.prev = _context19.next) {
                          case 0:
                            if (offset === 0) {
                              result = false;
                            }

                            if (!(offset < 0)) {
                              _context19.next = 15;
                              break;
                            }

                            i = 22;

                          case 3:
                            if (!(i >= 3)) {
                              _context19.next = 15;
                              break;
                            }

                            lastOffset = (0, _char.substrWidth)("dbcs", _this6.line[i].str, 3, 4).trim();

                            if (!(lastOffset.length > 0)) {
                              _context19.next = 8;
                              break;
                            }

                            offset += +lastOffset + 1;
                            return _context19.abrupt("break", 15);

                          case 8:
                            lastOffset = (0, _char.substrWidth)("dbcs", _this6.line[i].str, 15, 2).trim();

                            if (!(lastOffset.length > 0)) {
                              _context19.next = 12;
                              break;
                            }

                            offset += +lastOffset + 1;
                            return _context19.abrupt("break", 15);

                          case 12:
                            i--;
                            _context19.next = 3;
                            break;

                          case 15:
                            if (offset < 0) {
                              result = false;
                            }

                            if (result) {
                              _context19.next = 18;
                              break;
                            }

                            return _context19.abrupt("return");

                          case 18:
                            _context19.next = 20;
                            return _this6.send("".concat(offset).concat(_utils.keymap.Enter.repeat(2), " ").concat(_utils.keymap.Home).concat(_utils.keymap.End));

                          case 20:
                          case "end":
                            return _context19.stop();
                        }
                      }
                    }, _callee19);
                  }));

                  return function (_x11) {
                    return _ref2.apply(this, arguments);
                  };
                }());

                if (!result) {
                  _context20.next = 11;
                  break;
                }

                this.state.position.boardname = this.currentBoardname;
                this.emit("stateChange", this.state);
                _context20.next = 8;
                return this.send(_utils.keymap.Home);

              case 8:
                return _context20.abrupt("return", true);

              case 11:
                _context20.next = 13;
                return this.enterIndex();

              case 13:
                return _context20.abrupt("return", false);

              case 14:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function enterByOffset() {
        return _enterByOffset.apply(this, arguments);
      }

      return enterByOffset;
    }()
  }, {
    key: "enterBoardByOffset",
    value: function () {
      var _enterBoardByOffset = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21() {
        var offsets,
            _args21 = arguments;
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                offsets = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : [];
                _context21.next = 3;
                return this.send("C".concat(_utils.keymap.Enter));

              case 3:
                _context21.next = 5;
                return this.enterByOffset(offsets);

              case 5:
                return _context21.abrupt("return", _context21.sent);

              case 6:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function enterBoardByOffset() {
        return _enterBoardByOffset.apply(this, arguments);
      }

      return enterBoardByOffset;
    }()
  }, {
    key: "enterFavorite",
    value: function () {
      var _enterFavorite = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22() {
        var offsets,
            _args22 = arguments;
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                offsets = _args22.length > 0 && _args22[0] !== undefined ? _args22[0] : [];
                _context22.next = 3;
                return this.send("F".concat(_utils.keymap.Enter));

              case 3:
                _context22.next = 5;
                return this.enterByOffset(offsets);

              case 5:
                return _context22.abrupt("return", _context22.sent);

              case 6:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function enterFavorite() {
        return _enterFavorite.apply(this, arguments);
      }

      return enterFavorite;
    }()
  }, {
    key: "enterMail",
    value: function () {
      var _enterMail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23() {
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.send("M".concat(_utils.keymap.Enter, "R").concat(_utils.keymap.Enter).concat(_utils.keymap.Home).concat(_utils.keymap.End));

              case 2:
                return _context23.abrupt("return", true);

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function enterMail() {
        return _enterMail.apply(this, arguments);
      }

      return enterMail;
    }()
  }, {
    key: "currentBoardname",
    get: function get() {
      var boardRe = /*#__PURE__*/_wrapRegExp(/\u3010(?!\u770B\u677F\u5217\u8868).*\u3011.*\u300A(.*)\u300B/, {
        boardname: 1
      });

      var match = boardRe.exec(this.line[0].str);

      if (match) {
        return match.groups.boardname;
      } else {
        return void 0;
      }
    }
  }]);
  return Bot;
}(_eventemitter["default"]);

(0, _defineProperty2["default"])(Bot, "initialState", {
  connect: false,
  login: false,
  wsState: 0
});
(0, _defineProperty2["default"])(Bot, "forwardEvents", ["message", "error"]);
var _default = Bot;
exports["default"] = _default;